<template>
  <div id="app" class="cursor-pointer" @click="visualizarDocumento">
    <v-card tile flat>
      <v-card-title class="primary--text font-weight-bold body-1  my-0 py-3">
        <v-tooltip bottom>
          <template #activator="{ on }">
            <span v-on="on">{{ documento.tituloFormatado }}</span>
          </template>
          <span>Clique para Visualizar as informações da decisão</span>
        </v-tooltip>
        <v-spacer></v-spacer>
        <v-chip
          v-if="documento._source.jurisprudencia_situacao == 'Publicada'"
          class="mx-1 py-4"
          label
          small
          dark
          color="primary"
        >
          Jurisprudência Selecionada
        </v-chip>
        <show-pdf-documento
          @click.native.stop
          :edoc="documento._source.documento_edoc"
          :textButton="`e-doc ${documento._source.documento_edoc}`"
          :relacionados="documento._source.jurisprudencia_relacionados"
        />
      </v-card-title>

      <v-card-subtitle
        v-if="documento.processo_numero_completo"
        class="primary--text  mb-0 pb-0"
      >
        Processo
        <span class="primary--text mb-1 font-weight-bold">
          {{ documento.processo_numero_completo }}
        </span>
      </v-card-subtitle>

      <v-row
        no-gutters
        class="mx-3 mb-3 text-justify body-2 grey--text text--darken-1"
      >
        <span v-html="documento.descricaoFormatada"></span>
      </v-row>

      <v-dialog
        v-model="dialog"
        width="60%"
        hide-overlay
        scrollable
        transition="dialog-bottom-transition"
      >
        <v-card tile>
          <v-toolbar dark color="primary lighten-1" tile>
            <v-toolbar-title>
              DECISÃO {{ documento._source.documento_numero_ano }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn text dark @click="copyLink()">
                <v-icon class="mr-3">mdi-share-variant</v-icon>
                COMPARTILHAR LINK
              </v-btn>
              <v-btn icon dark @click="dialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <v-row class="pr-2 pt-2 body-1">
              <v-col cols="auto" class="mx-2">
                <span class="font-weight-bold">Número da Decisão</span>
                <div>{{ documento._source.documento_numero_ano }}</div>
              </v-col>
              <v-col cols="auto" class="mx-2">
                <span class="font-weight-bold">Tipo</span>
                <div>
                  {{ documento._source.jurisprudencia_tipo_descricao }}
                </div>
              </v-col>
              <v-col cols="auto" class="mx-2">
                <span class="font-weight-bold">eDoc</span>
                <div>{{ documento._source.documento_edoc }}</div>
              </v-col>
              <v-col cols="auto" class="mx-2">
                <span class="font-weight-bold">Processo</span>
                <div>
                  {{ documento._source.processo_numero_completo }}
                </div>
              </v-col>
              <v-col cols="auto" class="mx-2">
                <span class="font-weight-bold">Relator</span>
                <div>{{ documento._source.processo_relator }}</div>
              </v-col>
              <v-col cols="auto" class="mx-2">
                <span class="font-weight-bold">Sessão</span>
                <div>
                  {{ documento._source.sessao_tipo }} Nº{{
                    documento._source.sessao_numero
                  }}
                </div>
              </v-col>
              <v-col cols="auto" class="mx-2">
                <span class="font-weight-bold">Classificação Temática</span>
                <div
                  v-if="documento._source.jurisprudencia_classificacao_tematica"
                >
                  {{ documento._source.jurisprudencia_classificacao_tematica }}
                </div>
                <div v-else class="grey--text text--lighten-1">
                  Sem classificação temática.
                </div>
              </v-col>
            </v-row>
            <v-row class="pr-2">
              <v-col cols="auto" class="mx-2">
                <span class="font-weight-bold">Palavras-chave</span>
                <div v-if="palavrasChave.length">
                  <v-chip
                    v-for="(termo, index) in palavrasChave"
                    v-bind:key="index"
                    class="mr-2 mb-2"
                    color="primary"
                    outlined
                    label
                    @click="searchTermo(termo.assuntocompleto)"
                  >
                    {{ termo.assuntocompleto }}
                  </v-chip>
                </div>
                <div v-else class="grey--text text--lighten-1">
                  Nenhum termo informado
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="auto" class="mx-2">
                <span class="font-weight-bold">
                  Referência Legislativa
                </span>
                <div v-if="referenciasLegislativas.length">
                  <v-chip
                    v-for="(normativo, index) in referenciasLegislativas"
                    v-bind:key="index"
                    class="mr-2 mb-2"
                    label
                    color="primary"
                    outlined
                    @click="searchNormativo(normativo)"
                  >
                    <v-tooltip bottom>
                      <template #activator="{ on }">
                        <v-icon
                          v-on="on"
                          class="ml-0 mr-1"
                          left
                          @click.native.stop="
                            linkNormativo(normativo.linklegislacao)
                          "
                        >
                          mdi-link-box-variant
                        </v-icon>
                      </template>
                      <span>
                        Clique para acessar
                        {{ normativo.normativocompleto }}
                      </span>
                    </v-tooltip>
                    {{ normativo.normativocompleto }}
                  </v-chip>
                </div>
                <div v-else class="grey--text text--lighten-1">
                  Nenhuma referência legislativa associada
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="auto" class="mx-2">
                <span class="font-weight-bold">
                  Decisões Relacionadas (TCDF)
                </span>
                <div v-if="decisoesRelacionadas.length">
                  <span
                    v-for="(decisaoRelacionada, index) in decisoesRelacionadas"
                    v-bind:key="index"
                    label
                    color="primary"
                    outlined
                  >
                    <show-pdf-documento
                      v-if="decisaoRelacionada.edocrelacionado"
                      :edoc="decisaoRelacionada.edocrelacionado"
                      :documento="decisaoRelacionada"
                      :icon="'mdi-gavel'"
                      :showEdoc="true"
                      @click.native.stop
                      :textButton="
                        decisaoRelacionada.edocrelatoriovoto
                          ? `DECISÃO ${decisaoRelacionada.decisaorelacionada} - ${decisaoRelacionada.dsctipovoto}`
                          : `DECISÃO ${decisaoRelacionada.decisaorelacionada}`
                      "
                    />
                    <!-- Decisão {{ decisaoRelacionada.decisaorelacionada }} -->
                  </span>
                </div>
                <div v-else class="grey--text text--lighten-1">
                  Nenhuma decisão relacionada
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="auto" class="mx-2">
                <span class="font-weight-bold">
                  Precedentes Externos
                </span>
                <div v-if="precedentesExternos.length">
                  <v-tooltip bottom v-for="(precedente, index) in precedentesExternos">
                    <template #activator="{ on }">
                      <v-chip
                        v-on="on"
                        v-bind:key="index"
                        class="mr-2 mb-2"
                        label
                        color="primary"
                        outlined
                        @click.native.stop="
                          linkPrecedente(precedente.link)
                        "
                      >
                        <v-icon
                          class="ml-0 mr-1"
                          style="font-size: 19px;"
                          left
                        >
                          mdi-link-variant
                        </v-icon>

                        {{ precedente.precedentecompleto }}
                      </v-chip>
                    </template>
                    <span>
                      Clique para acessar
                      {{ precedente.precedentecompleto }}
                    </span>
                  </v-tooltip>
                </div>
                <div v-else class="grey--text text--lighten-1">
                  Nenhum precedente externo relacionado
                </div>
              </v-col>
            </v-row>
            <v-row
              v-if="documento._source.jurisprudencia_relacionados"
              class="pr-2"
            >
              <v-col cols="auto" class="mx-2">
                <span class="font-weight-bold">Documentos relacionados</span>
                <div class="text-justify">
                  <span
                    v-for="(docRelacionado, index) in documento._source
                      .jurisprudencia_relacionados"
                    v-bind:key="index"
                  >
                    <show-pdf-documento
                      v-if="docRelacionado.edoc"
                      :edoc="docRelacionado.edoc"
                      :documento="docRelacionado"
                      :icon="'mdi-gavel'"
                      :showEdoc="true"
                      @click.native.stop
                      :textButton="
                        `${docRelacionado.nometipodocumento} - eDoc ${docRelacionado.edoc}`
                      "
                    />
                    <span v-else class="grey--text text--lighten-1"
                      >Nenhum documento relacionado</span
                    >
                  </span>
                  <show-pdf-documento
                    v-if="documento._source.jurisprudencia_relacionados"
                    :edoc="documento._source.documento_edoc"
                    @click.native.stop
                    :icon="'mdi-eye'"
                    :textButton="`VISUALIZAR DOCUMENTO(S)`"
                    :outlined="false"
                    :documentosRelacionados="
                      documento._source.jurisprudencia_relacionados
                    "
                  />
                </div>
              </v-col>
            </v-row>
            <v-row class="pr-2">
              <v-col cols="auto" class="mx-2">
                <span class="font-weight-bold">Ementa do Voto</span>
                <div class="text-justify">
                  {{ documento._source.jurisprudencia_ementa_voto_gabinete === 'S' ?
                  documento._source.jurisprudencia_ementa_voto :
                  documento._source.jurisprudencia_ementa
                  }}
                </div>
              </v-col>
            </v-row>
            <v-row class="pr-2">
              <v-col cols="auto" class="mx-2">
                <span class="font-weight-bold">Texto da Decisão</span>
                <div class="text-justify">
                  {{ documento._source.jurisprudencia_decisao }}
                </div>
              </v-col>
            </v-row>
            <v-row v-if="documento._source.jurisprudencia_excerto" class="pr-2">
              <v-col cols="auto" class="mx-2">
                <span class="font-weight-bold">Excerto</span>
                <div
                  class="text-justify"
                  v-html="documento._source.jurisprudencia_excerto_html"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>
<script>
import ShowPdfDocumento from "./ShowPdfDocumento.vue";

export default {
  props: {
    documento: { type: Object },
    dialogCompartilhamento: { type: Boolean }
  },
  components: {
    ShowPdfDocumento
  },
  data() {
    return {
      dialog: false,
      obj: null,
      visualizado: false,
      url: process.env.VUE_APP_URL_BUSCA,
      darken: true,
      palavrasChave: [],
      referenciasLegislativas: [],
      decisoesRelacionadas: [],
      precedentesExternos: []
    };
  },
  created() {
    this.dialog = this.dialogCompartilhamento;
    this.loadPalavrasChaves();
    this.loadReferenciasLegislativas();
    this.loadDecisoesRelacionadas();
    this.loadPrecedentesExternos();
  },
  methods: {
    loadDecisoesRelacionadas() {
      this.decisoesRelacionadas = [];
      this.documento._source.jurisprudencia_decisoes_relacionadas.map(
        decisaoRelacionada => {
          if (decisaoRelacionada.edoc) {
            this.decisoesRelacionadas.push(decisaoRelacionada);
          }
        }
      );
    },
    loadReferenciasLegislativas() {
      this.referenciasLegislativas = [];
      this.documento._source.jurisprudencia_legislacao.map(
        referenciaLegislativa => {
          if (referenciaLegislativa.normativocompleto) {
            this.referenciasLegislativas.push(referenciaLegislativa);
          }
        }
      );
    },
    loadPrecedentesExternos() {
      this.precedentesExternos = [];
      this.documento._source.jurisprudencia_precedente_externo.map(
        precedenteExternos => {
          if (precedenteExternos.precedentecompleto) {
            this.precedentesExternos.push(precedenteExternos);
          }
        }
      );
    },
    loadPalavrasChaves() {
      this.palavrasChave = [];
      this.documento._source.jurisprudencia_assunto.map(palavraChave => {
        if (palavraChave.assuntocompleto) {
          this.palavrasChave.push(palavraChave);
        }
      });
    },
    copyLink() {
      const urlPrincipal = process.env.VUE_APP_URL_BUSCA.replace(/#/g, "");
      const link = `${urlPrincipal}#${this.$route.path}?q=${this.documento._source.documento_edoc}&filter[hash]=${this.documento._source.hash}`;
      navigator.clipboard.writeText(link);
      const objeto = {
        text: `Jurisprudência ${this.documento._source.documento_edoc} copiada para área de transferência com sucesso!`,
        color: "success"
      };
      this.$store.commit("SET_SNACK_MESSAGE", objeto);
    },
    visualizarDocumento() {
      this.dialog = !this.dialog;
    },
    colorJurispridencia(situacao) {
      if (situacao == "Descartada") {
        return "deep-orange lighten-3";
      }
      if (situacao == "Pré-Descartada") {
        return "orange lighten-3";
      }
      if (situacao == "Publicada") {
        return "blue darken-1";
      }
      if (situacao == "Capturada") {
        return "blue lighten-3";
      }

      if (situacao == "Em Análise") {
        return "blue lighten-3";
      }
    },
    searchTermo(termo) {
      this.$emit("newSearchTermo", termo);
    },
    searchNormativo(normativo) {
      this.$emit("newSearchNormativo", normativo);
    },
    searchDecisaoRelacionada(edocrelacionado) {
      console.log(edocrelacionado);
      //this.$emit("newSearchDecisao", edoc);
    },
    linkNormativo(link) {
      window.open(link, "_blank");
    },
    linkPrecedente(link) {
      window.open(link, "_blank");
    }
  }
};
</script>
